<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">SK Kepala Daerah</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>

                <div class="row">
                    <div class="col-sm-2">
                        <span>Kecamatan</span>
                    </div>
                    <div class="col-sm-3">
                        <select class="form-control">
                            <option>Kode - Kecamatan</option>
                            <option>010 - TINANGGEA</option>
                            <option>011 - LALEMBUU</option>
                            <option>020 - ANDOOLO</option>
                            <option>021 - BUKE</option>
                            <option>030 - PALANGGA</option>
                            <option>031 - PALANGGA SELATAN</option>
                            <option>032 - BAITO</option>
                            <option>040 - LAINEA</option>
                            <option>041 - LAEYA</option>
                            <option>050 - KOLONO</option>
                            <option>060 - LAONTI</option>
                            <option>070 - MORAMO</option>
                            <option>071 - MORAMO UTARA</option>
                            <option>080 - KONDA</option>
                            <option>081 - WOLASI</option>
                            <option>090 - RANOMEETO</option>
                            <option>091 - RANOMEETO BARAT</option>
                            <option>100 - LANDONO</option>
                            <option>101 - MOWILA</option>
                            <option>110 - ANGATA</option>
                            <option>111 - BENUA</option>
                            <option>112 - BASALA</option>
                            <option>113 - ANDOOLO BARAT</option>
                            <option>114 - SABULAKOA</option>
                            <option>115 - KOLONO TIMUR</option>
                        </select>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-2">
                        <span>Kelurahan</span>
                    </div>
                    <div class="col-sm-3">
                        <select class="form-control">
                            <option>Kode - Kelurahan</option>
                        </select>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-2">
                        <span>Tahun Pajak</span>
                    </div>
                    <div class="col-sm-1">
                        <input type="text" class="form-control">
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-2">
                        <span>Nomor Keputusan</span>
                    </div>
                    <div class="col-sm-3">
                        <input type="text" class="form-control">
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-2">
                        <span>Tanggal Keputusan</span>
                    </div>
                    <div class="col-sm-3">
                        <input type="text" class="form-control">
                    </div>
                </div>
                <br>

                <div class="row">
                    <div class="col-sm-2">
                        <span>Tabel Referensi</span>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <input type="radio" name="gender" id="radio1" class="with-gap">
                            <label for="radio1">SK ZNT eks SISTEP</label>
                            <br>
                            <input type="radio" name="gender" id="radio2" class="with-gap">
                            <label for="radio2">SK OP Dengan Nilai Individu</label>
                            <br>
                            <input type="radio" name="gender" id="radio3" class="with-gap">
                            <label for="radio3">SK Pemantauan OP</label>
                            <br>
                            <input type="radio" name="gender" id="radio4" class="with-gap">
                            <label for="radio4">SK ZNT SISMIOP</label>
                            <br>
                            <input type="radio" name="gender" id="radio5" class="with-gap">
                            <label for="radio5">Daftar Tabel Jalan Standar</label>
                            <br>
                            <input type="radio" name="gender" id="radio6" class="with-gap">
                            <label for="radio6">SK DBKB (Daftar Biaya Komponen Bangunan)</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-4">
                        <button type="button" class="btn bg-light-blue btn-sm waves-effect"><i class="material-icons">print</i> Cetak</button>
                    </div>
                </div>
                <br> <br>
        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {

    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
